import * as React from "react";
import { SmartPagination } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function SmartPaginationDemo() {
  // The pager is controlled, so each block owns its own page state and feeds it
  // back through onPageChange. Independent state per variant keeps the blocks
  // from cross-driving each other.
  const [sliding, setSliding] = React.useState(10);
  const [wide, setWide] = React.useState(10);
  const [compact, setCompact] = React.useState(3);

  return (
    <Section
      id="smart-pagination"
      title="SmartPagination"
      description="The smart windowing layer over the stock Pagination primitives. Pass only currentPage / totalPages / onPageChange and it pins the first and last page, slides a window around the current page, and inserts gap-aware ellipses. The sliding-window math lives in the reusable usePagination hook; the row composes the on-brand stock parts."
    >
      <VariantBlock label="Sliding (default)" caption="pinned first/last, window around current, gap-aware ellipses">
        <div className="flex w-full flex-col items-center gap-3">
          <SmartPagination
            currentPage={sliding}
            totalPages={20}
            onPageChange={setSliding}
          />
          <p className="text-xs text-muted-foreground">
            Page {sliding} of 20
          </p>
        </div>
      </VariantBlock>

      <VariantBlock label="Wider window" caption="siblingCount / boundaryCount widen the window and pins">
        <div className="flex w-full flex-col items-center gap-3">
          <SmartPagination
            currentPage={wide}
            totalPages={20}
            siblingCount={2}
            boundaryCount={2}
            onPageChange={setWide}
          />
          <p className="text-xs text-muted-foreground">
            Page {wide} of 20
          </p>
        </div>
      </VariantBlock>

      <VariantBlock label="Compact" caption="two-page navy pill row, slides back by one only on the last page">
        <div className="flex w-full flex-col items-center gap-3">
          <SmartPagination
            variant="compact"
            currentPage={compact}
            totalPages={6}
            onPageChange={setCompact}
          />
          <p className="text-xs text-muted-foreground">
            Page {compact} of 6
          </p>
        </div>
      </VariantBlock>
    </Section>
  );
}
